var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cabecalho',{attrs:{"title":"SUPRIMENTOS_LANCAMENTOS_NF.OBSERVACOES"}}),_c('b-card',[_vm._v(" "+_vm._s(_vm.observacoes)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }